import { type FormInstance, Form, Input } from 'antd5';
import { useTranslation } from 'react-i18next';

import { AttachmentCategoryChooser } from 'components/RecordAttachments/AttachmentCategoryChooser';

import { StyledItem } from './EditAttachmentForm.style';

interface EditAttachmentFormProps {
  form: FormInstance<any>;
  handleChange: any;
  categoryOnChange: any;
  defaultCategoryId: string | undefined;
  parentType: any;
  defaultDescription: string | undefined | null;
  disabled?: boolean;
}

export const EditAttachmentForm: React.FunctionComponent<EditAttachmentFormProps> = ({
  form,
  handleChange,
  categoryOnChange,
  defaultCategoryId,
  parentType,
  defaultDescription,
  disabled = false,
}) => {
  const { t } = useTranslation();
  return (
    <Form
      form={form}
      layout="vertical"
      onChange={handleChange}
      // Need to specify that the form shouldn't preserve its state, as this doesn't get cleared out even if the modal destroys itself on close.
      preserve={false}
    >
      <StyledItem label={t('attachments.category', 'Category')} name="category">
        <AttachmentCategoryChooser
          onChange={categoryOnChange}
          type={parentType}
          defaultCategoryId={defaultCategoryId}
          disabled={disabled}
        />
      </StyledItem>
      <StyledItem
        label={t('forms.description', 'Description')}
        name="description"
        initialValue={defaultDescription}
      >
        <Input
          data-testid="edit-attachment-description"
          placeholder={t('attachments.noDescriptionPlaceholder', 'No description')}
          allowClear={true}
          disabled={disabled}
        />
      </StyledItem>
    </Form>
  );
};
